module.exports = __webpack_public_path__ + "static/media/3.4231cf74.jpeg";